//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'Material',
    inheritAttrs: false,
    props: {
        spinnerProps: {
            type: Object,
            default: () => ({})
        }
    }
};
